import {
  STATS_GET,
  STATS_LOADING,
  STATS_ERROR,
} from '../actions/types';

const DEFAULT_STATE = {
  stats: null,
  isLoading: [],
  error: null,
};

const statsReducer = (state = DEFAULT_STATE, action) => {
  let updatedState = {};
  switch (action.type) {
    case STATS_GET:
      updatedState = {
        ...state,
        stats: action.payload,
        isLoading: state.isLoading?.filter((d) => d !== STATS_GET),
        error: null,
      };
      break;
    case STATS_LOADING:
      updatedState = { ...state, isLoading: [...state.isLoading, action.payload] };
      break;
    case STATS_ERROR:
      updatedState = { ...state };
      break;
    default:
      updatedState = { ...state };
      break;
  }
  return updatedState;
};

export default statsReducer;
